import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store/index";
import i18n from "../i18n/index"; // 你的i18n实例

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
console.log("process.env.NODE_ENV", process.env.NODE_ENV);

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "development" ? "" : "",
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("理由进入", to);
  console.log(process.env.NODE_ENV);
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  store.commit("changeTabActive", to.path);
  if (to.query.token) {
    sessionStorage.setItem("token", to.query.token);
  }
  // 处理语言设置：优先级：URL参数 > 特定页面强制英语 > sessionStorage
  // if (to.path === "/decorationShop" || to.path === "/myDecoration") {
  //   console.log("装饰商城或我的装扮页面");
  //   // 如果是装饰商城或我的装扮页面，固定使用英语
  //   sessionStorage.setItem("language", "en");
  //   i18n.locale = "en";
  // } else
  if (to.query.language) {
    sessionStorage.setItem("language", to.query.language);
    i18n.locale = to.query.language; // 直接使用注入的 i18n 实例
  } else if (sessionStorage.getItem("language")) {
    // 其他页面使用 sessionStorage 中保存的语言
    i18n.locale = sessionStorage.getItem("language");
  }
  next();
});

export default router;
